import Form from './form.component';

export default Form;
